// newsletter.js 			                             ~/js/
////////////////////////////////////////////////////////////

const email = document.getElementById('newsletterEmail');
if (email) {
  const emailPlaceholder = email.placeholder;
  email.addEventListener('focus', () => {
    email.placeholder = '';
  });

  email.addEventListener('blur', () => {
    if (email.value === '') {
      email.placeholder = emailPlaceholder;
    }
  });
}
